import React from 'react';
import { Switch } from 'react-router-dom';
import { useRouteMatch } from 'react-router';
import { FasitApmRoute } from '../../apm/fasit-apm-route';
import { joinURL } from '../../utilities';
import {
  attendanceCitizenImport,
  attendanceCitizenLessonDeviationPath,
  attendanceClassroomPath,
  attendanceClassroomsPathName,
  attendanceCourseEnrollmentPath,
  attendanceCoursePath,
  attendanceCourseStatisticsPath,
  attendanceCoursesAreaPathName,
  attendanceEducatorPath,
  attendanceEducatorsPathName,
  attendanceLessonPath,
  attendanceLessonProtocolPath,
  attendancePrintSchedulePathName,
  attendanceRegistrationCounterPath,
  attendanceRegistrationCountersPathName,
  attendanceSendSchedulePathName,
  attendanceStatisticsPathName,
} from './attendance-area-pathnames';
import { Course } from './course/course-uniform/course';

import { Lesson } from './lesson/lesson-uniform/lesson';
import { CitizenLessonDeviation } from './lesson/citizen-lesson-deviation-uniform/citizen-lesson-deviation';
import { Educator } from './educator/educator-uniform/educator';
import { EducatorsPage } from './educator/educators-page/educators-page';
import { CourseEnrollment } from './course-enrollment/course-enrollment-uniform/course-enrollment';
import { AttendanceProtocol } from './components/attendance-protocol/attendance-protocol';
import { AttendanceImport } from './attendance-import/attendance-import-uniform/attendance-import';
import { useFeatureToggles } from '../../feature-toggles';
import { useTenantAddons } from '../../components/tenant-addons';
import { CircularProgressCentered } from '../../components/circular-progress-centered';
import { PageNotFound } from '../../404';
import { PrintSchedule } from './schedule/print-schedule-uniform/print-schedule';
import { AttendanceStatistics } from './statistics/attendance-statistics';
import { ClassroomsPage } from './classroom/classrooms-page';
import { CoursesPage } from './course/courses-page/courses-page';
import { Classroom } from './classroom/classroom-uniform/classroom';
import { RegistrationCountersPage } from './registration-counter/registration-counters-page';
import { RegistrationCounter } from './registration-counter/registration-counter-uniform/registration-counter';

export function AttendanceArea() {
  const match = useRouteMatch();
  const { isFeatureEnabled } = useFeatureToggles();
  const { isTenantAddonEnabled, tenantAddons } = useTenantAddons();

  if (tenantAddons === undefined) {
    return <CircularProgressCentered />;
  }

  return isTenantAddonEnabled(['attendance']) && isFeatureEnabled('EnableAttendance') ? (
    <Switch>
      <FasitApmRoute path={joinURL(match.path, attendanceCoursePath)} exact>
        <Course />
      </FasitApmRoute>
      <FasitApmRoute path={joinURL(match.path, attendanceLessonPath)} exact>
        <Lesson />
      </FasitApmRoute>
      <FasitApmRoute path={joinURL(match.path, attendanceLessonProtocolPath)} exact>
        <AttendanceProtocol />
      </FasitApmRoute>
      <FasitApmRoute path={joinURL(match.path, attendanceCitizenLessonDeviationPath)} exact>
        <CitizenLessonDeviation />
      </FasitApmRoute>
      <FasitApmRoute path={joinURL(match.path, attendanceEducatorPath)} exact>
        <Educator />
      </FasitApmRoute>
      <FasitApmRoute path={joinURL(match.path, attendanceEducatorsPathName)} exact>
        <EducatorsPage />
      </FasitApmRoute>
      <FasitApmRoute path={joinURL(match.path, attendanceCoursesAreaPathName)} exact>
        <CoursesPage />
      </FasitApmRoute>
      <FasitApmRoute path={joinURL(match.path, attendanceClassroomsPathName)} exact>
        <ClassroomsPage />
      </FasitApmRoute>
      <FasitApmRoute path={joinURL(match.path, attendanceClassroomPath)} exact>
        <Classroom />
      </FasitApmRoute>
      <FasitApmRoute path={joinURL(match.path, attendanceRegistrationCountersPathName)} exact>
        <RegistrationCountersPage />
      </FasitApmRoute>
      <FasitApmRoute path={joinURL(match.path, attendanceRegistrationCounterPath)} exact>
        <RegistrationCounter />
      </FasitApmRoute>
      <FasitApmRoute path={joinURL(match.path, attendanceCourseEnrollmentPath)} exact>
        <CourseEnrollment />
      </FasitApmRoute>
      <FasitApmRoute path={joinURL(match.path, attendanceCitizenImport)} exact>
        <AttendanceImport />
      </FasitApmRoute>
      <FasitApmRoute path={joinURL(match.path, attendancePrintSchedulePathName)} exact>
        <PrintSchedule />
      </FasitApmRoute>
      {isFeatureEnabled('EnableSendCitizenSchedule') && (
        <FasitApmRoute path={joinURL(match.path, attendanceSendSchedulePathName)} exact>
          <PrintSchedule sendToCitizen />
        </FasitApmRoute>
      )}
      <FasitApmRoute path={joinURL(match.path, attendanceStatisticsPathName)} exact>
        <AttendanceStatistics />
      </FasitApmRoute>
      <FasitApmRoute path={joinURL(match.path, attendanceCourseStatisticsPath)} exact>
        <AttendanceStatistics />
      </FasitApmRoute>
    </Switch>
  ) : (
    <PageNotFound />
  );
}
